<template>
    <aside v-show="(!isMobile && modals.fullscreen) || (isMobile && modals.hamburgerMenu)"
           :class="{mobile: isMobile ,dash: modals.fullscreen}"
           @click="activeSelect = false"
           class="fs">
        <ul>

            <div class="head fs" :class="{mobile: isMobile}">
                <div class="avatar">
                    <div class="circle">
                        <i class="material-icons" :class="{hide: user.avatar}">person</i>
                        <img :src="user.avatar ? apiBase+'/avatar/'+user.avatar : ''" :class="{hide: !user.avatar}"/>
                    </div>
                </div>
                <span class="name">{{ user.fullname }}</span>
                <span class="id" v-if="['bullden','uccglobal'].indexOf(brand) === -1"># {{ user.id }}</span>
                <span class="email">{{ user.email }}</span>
            </div>

            <button :class="{active: modalFullscreen.page==='deposit'}" class="deposit-btn fs-normal"
                    @click="changePage('deposit')">{{ tokens.fullScreen.deposit }}
            </button>
            <div class="switch" v-if="whiteTheme && isMobile && !onlyWhiteTheme" :class="{active: lightTheme}" @click="switchTheme">
                    <div class="dark">
                        <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 26" fill="none">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M16.8541 25.5321C14.9465 26.0547 12.9292 26.1218 10.9631 25.7281C8.99706 25.3343 7.13654 24.4907 5.52997 23.2644C3.92339 22.0381 2.6152 20.463 1.70972 18.6649C0.804239 16.8667 0.32652 14.8952 0.314659 12.9075C0.302796 10.9198 0.75712 8.97095 1.6414 7.21636C2.52568 5.46177 3.81545 3.94997 5.40785 2.80153C7.00026 1.65309 8.85124 0.899784 10.8132 0.601678C12.7752 0.303572 14.7938 0.468917 16.7082 1.08453C14.4117 1.6864 12.3558 2.93599 10.783 4.68588C9.67642 5.91662 8.83084 7.3602 8.29457 8.93408C7.7583 10.5079 7.54185 12.1812 7.65761 13.8583C7.77338 15.5353 8.21907 17.1831 8.96922 18.7076C9.71936 20.2321 10.7592 21.6032 12.0294 22.7427C13.419 24.0142 15.0677 24.9674 16.8541 25.5321Z" fill="#fff"/>
                        </svg>
                    </div>

                    <div class="light">
                        <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 23 24" fill="none">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M7.51448 3.82869C7.21508 3.70277 6.12701 3.27318 5.58662 3.08801C5.15895 2.92709 4.71196 2.82496 4.25757 2.78433C4.07501 2.84359 4.07501 3.76203 4.13343 4.31753C4.19185 4.87304 4.39632 5.5989 4.44014 5.93961C4.6227 6.97656 7.82118 3.97682 7.51448 3.85831V3.82869ZM13.9772 2.91025C13.7946 2.59917 13.1958 1.56222 12.9475 1.07338C12.725 0.677215 12.4415 0.319654 12.1077 0.0142102C11.9252 -0.111705 11.3191 0.628971 11.0781 1.05856C10.8371 1.48815 10.4136 2.23624 10.2967 2.48066C9.74904 3.3991 14.1013 3.22133 13.948 2.91025H13.9772ZM14.2766 5.19894C13.5276 5.00082 12.7576 4.89635 11.9836 4.88785C11.2288 4.89629 10.4781 5.0008 9.74904 5.19894C8.01982 5.74779 6.54164 6.90676 5.58235 8.46584C4.62305 10.0249 4.24611 11.881 4.51981 13.6976C4.79352 15.5143 5.69977 17.1715 7.07435 18.3688C8.44893 19.5662 10.2009 20.2245 12.0128 20.2245C13.8247 20.2245 15.5767 19.5662 16.9513 18.3688C18.3258 17.1715 19.2321 15.5143 19.5058 13.6976C19.7795 11.881 19.4026 10.0249 18.4433 8.46584C17.484 6.90676 16.0058 5.74779 14.2766 5.19894ZM19.4686 6.42105C19.5344 6.05071 19.7096 4.88785 19.8338 4.33975C19.9457 3.89442 19.9655 3.43042 19.8922 2.97691C19.8338 2.79174 18.9283 2.91766 18.3879 3.09542C17.8475 3.27318 17.1757 3.59167 16.9274 3.65092C15.905 4.01386 19.4029 6.70991 19.4613 6.40624L19.4686 6.42105ZM21.5206 12.6649C21.7616 12.4798 22.6744 11.6872 23.0907 11.3169C23.4442 11.0445 23.7502 10.7141 23.9962 10.3392C24.0619 10.1541 23.2659 9.66521 22.7328 9.48004C22.1998 9.29487 21.5206 9.05045 21.2724 8.93194C20.25 8.5616 21.2139 12.9094 21.5133 12.6353L21.5206 12.6649ZM19.0451 18.7903H21.1044C21.574 18.8125 22.0439 18.7498 22.4919 18.6052C22.6744 18.5459 22.3093 17.6275 22.0683 17.1238C21.7755 16.6726 21.5121 16.2025 21.2797 15.7165C20.7393 14.8573 18.7457 18.7755 19.0451 18.7755V18.7903ZM13.3126 21.916C13.5536 22.0937 14.4591 22.8937 14.8827 23.2566C15.2265 23.5598 15.6129 23.8094 16.0292 23.9973C16.2702 24.0565 16.5769 23.1381 16.6937 22.59C16.8105 22.0419 16.8763 21.3012 16.9347 20.9901C17.1172 19.9532 13.0717 21.6715 13.2834 21.916H13.3126ZM6.9741 20.5457C7.03252 20.8494 7.21508 22.0271 7.33192 22.5678C7.36805 23.0153 7.4922 23.451 7.69704 23.8491C7.8796 24.0343 8.66827 23.6047 9.08451 23.2344C9.50075 22.864 10.0557 22.3826 10.2967 22.1974C11.0781 21.5234 6.91568 20.1754 6.9741 20.5457ZM2.93582 15.3388C2.81168 15.5832 2.20558 16.6276 1.9719 17.1164C1.70312 17.5 1.51656 17.9365 1.42421 18.3978C1.42421 18.5829 2.32972 18.7681 2.88471 18.7681H4.44014C5.64504 18.7681 3.04536 15.1536 2.92852 15.3388H2.93582ZM3.17681 8.72455C2.8774 8.85046 1.78934 9.27265 1.24165 9.46522C0.804243 9.60221 0.390397 9.80709 0.0148327 10.0726C-0.102007 10.2577 0.496796 10.991 0.92034 11.2947C1.34388 11.5984 1.89157 12.1539 2.13255 12.339C2.91392 13.0131 3.4543 8.63567 3.1549 8.72455H3.17681Z" fill="#258BD4"/>
                        </svg>
                    </div>
            </div>
            <li :class="{active: modalFullscreen.page==='dashboard' }" @click="changePage('dashboard')"><i
                class="material-icons">dashboard</i>{{ tokens.fullScreen.dashboard }}
            </li>
            <li :class="{active: modalFullscreen.page==='personal' }" @click="changePage('personal')"><i
                class="material-icons">account_circle</i>{{ tokens.fullScreen.personalInfo }}
            </li>
            <li :class="{active: modalFullscreen.page==='withdrawal'}" @click="changePage('withdrawal')"><i
                class="material-icons">monetization_on</i>{{ tokens.fullScreen.withdrawal }}
            </li>
            <li v-if="!hideVerificationTab" :class="{active: modalFullscreen.page==='verification'}" @click="changePage('verification')"><i
                class="material-icons">badge</i>{{ tokens.fullScreen.verification }}
            </li>
            <li :class="{active: modalFullscreen.page==='accounts' }" @click="changePage('accounts')"><i
                class="material-icons">content_copy</i>{{ tokens.fullScreen.accounts }}
            </li>
            <li v-if="!hideLiveChat" :class="{active: modalFullscreen.page==='support' }" @click="changePage('support')"><i
                class="material-icons">chat</i>{{ tokens.fullScreen.liveChat }}
            </li>
            <li v-if="savingExist" :class="{active: modalFullscreen.page==='savings'}" @click="changePage('savings')">
                <i class="material-icons">savings</i>
                {{ 
                    ['stage_sharksoft','novixgrade','nexbergag','crownexcapitalgroup','vertexcapitalgroup'].includes(brand) ? 
                        { gb: 'Staking', de: 'Festgeld' }[langActive] || tokens.fullScreen.savings : 
                        tokens.fullScreen.savings 
                }}
            </li>
            <li :class="{active: modalFullscreen.page==='settings' }" @click="changePage('settings')"><i
                class="material-icons">settings</i>{{ tokens.fullScreen.settings }}
            </li>
        </ul>
        <div class="side-menu">
            <div class="menu" :class="{hide: modals.fullscreen}">
                <div class="item" :class="{active: modalMenu.market, isMobile: isMobile}"
                     @click="showMenuModal('market')">
                    <i class="material-icons">view_list</i>
                    <span>{{ tokens.sideMenu.marketWatch.toUpperCase() }}</span>
                    <i class="material-icons toggle-btn"
                       :class="{hide: modalMenuSplit > 1 && !modalMenu.market, minus: modalMenu.market && modalMenuSplit > 0}"
                       @click.stop="toggleWidget('market')">{{ modalMenu.market ? 'remove_circle' : 'add_circle' }}</i>
                </div>
                <div class="item" :class="{active: modalMenu.orders, isMobile: isMobile}"
                     @click="showMenuModal('orders')">
                    <i class="material-icons">local_mall</i>
                    <span>{{ tokens.sideMenu.activeOrders.toUpperCase() }}</span>
                    <i class="material-icons toggle-btn"
                       :class="{hide: modalMenuSplit > 1 && !modalMenu.orders, minus: modalMenu.orders && modalMenuSplit > 0 }"
                       @click.stop="toggleWidget('orders')">{{ modalMenu.orders ? 'remove_circle' : 'add_circle' }}</i>
                </div>
                <div class="item" :class="{active: modalMenu.history, isMobile: isMobile}"
                     @click="showMenuModal('history')">
                    <i class="material-icons">history</i>
                    <span>{{ tokens.sideMenu.tradingHistory.toUpperCase() }}</span>
                    <i class="material-icons toggle-btn"
                       :class="{hide: modalMenuSplit > 1 && !modalMenu.history, minus: modalMenu.history && modalMenuSplit > 0}"
                       @click.stop="toggleWidget('history')">{{
                            modalMenu.history ? 'remove_circle' : 'add_circle'
                        }}</i>
                </div>
                <div class="item" :class="{active: modalMenu.calendar, isMobile: isMobile}"
                     @click="showMenuModal('calendar')">
                    <i class="material-icons">today</i>
                    <span>{{ tokens.sideMenu.economicCalendar.toUpperCase() }}</span>
                    <i class="material-icons toggle-btn"
                       :class="{hide: modalMenuSplit > 1 && !modalMenu.calendar, minus: modalMenu.calendar && modalMenuSplit > 0}"
                       @click.stop="toggleWidget('calendar')">{{
                            modalMenu.calendar ? 'remove_circle' : 'add_circle'
                        }}</i>
                </div>
                <div class="item" :class="{active: modalMenu.news, isMobile: isMobile}" @click="showMenuModal('news')">
                    <i class="material-icons">campaign</i>
                    <span>{{ tokens.sideMenu.marketNews.toUpperCase() }}</span>
                    <i class="material-icons toggle-btn"
                       :class="{hide: modalMenuSplit > 1 && !modalMenu.news, minus: modalMenu.news && modalMenuSplit > 0}"
                       @click.stop="toggleWidget('news')">{{ modalMenu.news ? 'remove_circle' : 'add_circle' }}</i>
                </div>
            </div>
        </div>
        <li class="logout" v-on:click="logout"><i class="material-icons">logout</i><span>{{
                tokens.fullScreen.logOut
            }}</span></li>

    </aside>
</template>

<script>
import {mapGetters, mapMutations} from 'vuex'
import {MODAL, MODAL_FULLSCREEN, MODAL_MENU, ACTIVE_CURRENCY} from "@/store/mutations.type";
import {isMobile} from '@/common/helpers'
import {LOGOUT} from "@/store/actions.type";
import {REST_ENDPOINT, STATIC_BASE, BRAND, HIDE_VERIFICATION_TAB, WHITE_THEME, TRADINGVIEW_THEME, TRADINGVIEW_BG, TRADINGVIEW_LINE, ONLY_WHITE_THEME, HIDE_LIVE_CHAT} from "@/common/config";

export default {
    name: "SideMenu",
    data() {
        return {
            isMobile: isMobile(),
            staticBase: STATIC_BASE,
            apiBase: REST_ENDPOINT,
            activeSelect: false,
            brand: BRAND,
            hideVerificationTab: HIDE_VERIFICATION_TAB,
            whiteTheme: WHITE_THEME,
            onlyWhiteTheme: ONLY_WHITE_THEME,
            hideLiveChat: HIDE_LIVE_CHAT
        }
    },
    methods: {
        ...mapMutations(["setLightTheme",'setThemeColors']),
        switchTheme(){
            this.setLightTheme(!this.lightTheme)
            localStorage.setItem('theme',this.lightTheme ? 'white' : 'black')
            localStorage.setItem('tradingview.current_theme.name',this.lightTheme ? 'Light' : TRADINGVIEW_THEME)

            let theme = this.lightTheme ? 
                {
                    ...this.themeColors,
                    'background-dark': '#fff',
                    'line': '#fff'
                } : 
                {
                    ...this.themeColors,
                    'background-dark': TRADINGVIEW_BG,
                    'line': TRADINGVIEW_LINE
                }

            this.setThemeColors(theme)

            if (document.body.classList.contains('light-theme')) {
                document.body.classList.remove('light-theme');
            }

            if (this.lightTheme) {
                document.body.classList.add('light-theme');
            }
        },
        showMenuModal(item) {
            this.$store.commit(MODAL, {
                menu: true
            })

            let m = {
                orders: false,
                history: false,
                market: false,
                calendar: false,
                news: false
            }

            m[item] = true

            this.$store.commit(MODAL_MENU, m)
            this.$store.commit(MODAL, {
                hamburgerMenu: false
            })
        },
        toggleWidget(widget) {
            let n = JSON.parse(JSON.stringify(this.modalMenu))

            n[widget] = !n[widget]

            this.$store.commit(MODAL_MENU, n)

            let hideMenuModal = true

            for (let i in n) {
                if (n[i]) {
                    hideMenuModal = false
                    break
                }
            }

            if (hideMenuModal) {
                this.$store.commit(MODAL, {
                    menu: false,
                    sideMenu: !isMobile()
                })
            }

            if (n[widget] && !this.modals.menu) {
                this.$store.commit(MODAL, {
                    menu: true,
                    sideMenu: false
                })
            }

            this.$store.commit(MODAL, {
                hamburgerMenu: false
            })

        },
        changePage(page) {
            this.$store.commit(MODAL, {
                fullscreen: true
            })

            this.$store.commit(MODAL, {
                hamburgerMenu: false
            })

            this.$store.commit(MODAL_FULLSCREEN, {
                page
            })
        },
        changeCurrency(currency) {
            localStorage.activeCurrency = currency
            this.$store.commit(ACTIVE_CURRENCY, currency)
        },
        logout() {
            this.$store.dispatch(LOGOUT)
        },
    },
    computed: {
        ...mapGetters(['tokens', 'modals', 'modalMenu', 'modalFullscreen', 'user', 'accounts', 'activeAccount', 'activeCurrency','savingExist','lightTheme','themeColors' ,'langActive']),
        modalMenuSplit() {
            let i = 0
            for (let n in this.modalMenu) {
                if (this.modalMenu[n]) {
                    i++
                }
            }

            return i
        }
    }
}
</script>

<style scoped>

.dashboard-menu {
    padding-top: 20px;
    margin-top: 20px;
    border-top: 2px solid var(--white);
}

.menu {
    display: flex;
    flex-direction: column;
    overflow-y: scroll;
}

.menu .item {
    width: 80px;
    height: 80px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    cursor: pointer;
    font-weight: 400;
    font-size: 0.9em;
    position: relative;
    padding: 0 10px;
    border-bottom: 1px solid var(--background-dark);
    transition: background-color ease-in-out 0.3s, color ease-in-out 0.3s;
    text-align: center;
}

.menu .item i {
    margin-bottom: 5px;
}

.menu .item span {
    text-align: center;
}

.menu .item:hover, .menu .item.active {
    color: var(--white);
    background-color: var(--background-light);
}

.menu .item:hover .toggle-btn, .toggle-btn.minus {
    opacity: 1;
}

.head {
    place-self: center end;
    text-align: right;
    display: flex;
    align-items: center;
    flex-direction: column;
    padding: 20px 0;
    margin: 0 auto;
}

.head.mobile {
    padding: 40px 0;
}

.avatar {
    transition: color ease-in-out 0.3s;
    display: flex;
    align-items: center;
}

.avatar .circle {
    height: 70px;
    width: 70px;
    border-radius: 50%;
    background-color: var(--background);
    transition: background-color ease-in-out 0.3s;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    border: 1px solid transparent;

}

.light-theme .avatar .circle {
    border-color: var(--white-to-black);

}


.avatar .circle img {
    height: 70px;
    width: 70px;
    object-fit: cover;
}

.name {
    font-weight: 600;
    font-size: 24px;
    line-height: 30px;
    color: #91BDFF;
    margin: 15px 0 15px;
    max-width: 175px;
    text-align: center;
    word-wrap: break-word;
    word-break: break-word;
}

.id,
.email {
    font-weight: 300;
    font-size: 18px;
    line-height: 25px;
}

.id {
    color: #C0C0C0;
}

.email {
    color: var(--white-to-black);
}

.toggle-btn {
    position: absolute;
    top: 5px;
    right: 5px;
    font-size: 1.6em;
    color: var(--font);
    cursor: pointer;
    transition: color ease-in-out 0.3s, opacity ease-in-out 0.3s;
    opacity: 0;
}

.isMobile .toggle-btn {
    opacity: 1;
    top: 1px;
    right: 3px;
}

.isMobile .material-icons:last-child {
    display: none;
}

.isMobile .material-icons {
    padding: 0;
}

.toggle-btn:hover {
    color: var(--white);
}

aside {
    background: var(--background-dark-mid);
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    z-index: 10;
    padding: 0 38px;
    position: fixed;
    top: 0;
    left: 0;
    height: 100%;
    overflow-y: scroll;
    box-shadow: 0 0 10px 4px rgba(0, 0, 0, .1);
}

aside {
    padding: 0 15px;
}

aside li {
    font-size: 24px;
    grid-auto-rows: 50px;
    line-height: 24px;
}

aside i {
    font-size: 21px;
    padding: 0 20px 0 0;
}

aside li,
.logout {
    display: grid;
    grid-template-columns: auto 1fr;
    grid-auto-rows: 50px;
    place-items: center start;
    cursor: pointer;
    font-weight: 400;
    font-size: 18px;
    line-height: 25px;
    color: var(--font);
}

aside li:hover,
aside li.active {
    color: var(--white-to-black);
}

.menu {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: repeat(3, 1fr);
    padding: 20px 0;
}

.menu .item {
    width: 80px;
    height: 80px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    cursor: pointer;
    font-weight: 400;
    font-size: 0.9em;
    position: relative;
    padding: 0 10px;
    border-bottom: 1px solid var(--background-dark);
    transition: background-color ease-in-out 0.3s, color ease-in-out 0.3s;
}

.menu .item i {
    margin-bottom: 5px;
}

.menu .item span {
    text-align: center;
}

.menu .item:hover, .menu .item.active {
    color: var(--white);
    background-color: var(--background-light);
}

.menu .item:hover .toggle-btn, .toggle-btn.minus {
    opacity: 1;
}

.toggle-btn {
    position: absolute;
    top: 5px;
    right: 5px;
    font-size: 1.6em;
    color: var(--font);
    cursor: pointer;
    transition: color ease-in-out 0.3s, opacity ease-in-out 0.3s;
    opacity: 0;
}

.isMobile .toggle-btn {
    opacity: 1;
    top: 1px;
    right: 3px;
}

.toggle-btn:hover {
    color: var(--white);
}

.deposit-btn.fs-normal {
    width: 100%;
    margin: 0 0 20px;
}

.avatar .circle i {
    padding: 0 20px 0;
}

.light-theme aside li.active{
    color: var(--green);
}

@media (min-width: 1000px) {
    .head {
        padding: 1vw 0;
    }

    .avatar .circle i {
        padding: 0 1vw 0;
    }

    .head.fs .avatar .circle {
        width: 3.5vw;
        height: 3.5vw;
    }

    .head.fs .avatar .circle img {
        width: 100%;
        height: 100%;
    }

    .head.fs .name {
        font-size: 1.25vw;
        line-height: 1.8vw;
        max-width: 9vw;
        margin: 1vw 0;
    }

    .head.fs .id,
    .head.fs .email {
        font-size: 1vw;
        line-height: 1.4vw;
    }

    .deposit-btn.fs-normal {
        margin: 0 0 1.2vw;
    }

    aside.fs {
        padding: 0 2vw;
    }

    aside.fs li {
        font-size: 1.2vw;
        grid-auto-rows: 2.5vw;
        line-height: 1.4vw;
    }

    aside.fs i {
        font-size: 1.2vw;
        padding: 0 1vw 0 0;
    }

}

@media (max-width: 1000px) {
    aside.fs li {
        grid-auto-rows: 50px;
    }
}

@media (max-width: 500px) {

    aside.mobile {
        padding: 70px 20px 0;
    }

}

</style>
